import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ComponentManager from '@/Management/ComponentManager';
import {PropertyClearUIListenerParams, PropertyClearUIListenerRule} from '#/DefaultViewExtensionInterfaces';

export default class PropertyClearUIListener extends UIListener {
    private readonly rules: PropertyClearUIListenerRule[];

    constructor(params: PropertyClearUIListenerParams) {
        super();

        this.rules = this.paramOrDefault(params.rules, []);
    }

    /**
     * @override
     */
    public onPropertyValueUpdated(context: DetailViewContext, property: string) {
        this.checkRules(context, property);
    }

    private checkRules(context: DetailViewContext, property: string): void {
        for (const rule of this.rules) {
            if (rule.propertiesToWatch.indexOf(property) < 0) {
                continue;
            }
            this.applyRule(context, rule);
        }
    }

    private applyRule(context: DetailViewContext, rule: PropertyClearUIListenerRule): void {
        const genericObject = context.genericObject;
        for (const propertyToClear of rule.propertiesToClear) {
            const observable = genericObject.getObservable(propertyToClear);
            if (!observable) {
                continue;
            }

            observable(null);
        }
    }
}

ComponentManager.setUIListener('PropertyClearUIListener', PropertyClearUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');